export enum SearchMode {
  QUICK = "quick",
  DEEP = "deep",
  ONLINE = "online",
}

export const SEARCH_MODE_OPTIONS: {
  value: SearchMode
  label: string
  description: string
}[] = [
  {
    value: SearchMode.QUICK,
    label: "Quick Response",
    description: "Fast answer from indexed documents",
  },
  {
    value: SearchMode.DEEP,
    label: "Think Deeper",
    description: "Full reasoning pipeline for complex questions",
  },
  {
    value: SearchMode.ONLINE,
    label: "Online Search",
    description: "Search the web for up-to-date information",
  },
]
